import { BlockedUserDetailsProvider } from '@exam-center/blocked-user-details';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { useParams } from '@exam-center/router';
import { PermissionGuard } from '@shared/permissions';

export default function BlockedUserDetailsLayout() {
  const { blockedUserId } = useParams('/admin/blocklist/:blockedUserId');

  return (
    <PermissionGuard
      requiredPermission={APP_PERMISSIONS.ADMIN_BLOCKLIST_MANAGEMENT.BLOCKED_USER.VIEW}
    >
      <BlockedUserDetailsProvider blockedUserId={blockedUserId} />
    </PermissionGuard>
  );
}
